"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.implementStaticService = exports.defineStaticService = void 0;
const helpers_1 = require("@wix/services-manager/helpers");
exports.defineStaticService = helpers_1.defineService;
exports.implementStaticService = helpers_1.implementService;
//# sourceMappingURL=staticService.js.map